var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-my-clients-submenu'),_c('v-row',{staticClass:"mx-5"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"pb-2"},[_c('q-placed-policy-data-table',{attrs:{"agent":_vm.user.Agent,"rows":25,"title":"Placed Policies"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }